export function truncateText(text, maxLength) {
  if (text !== undefined && text !== null) {
    if (typeof text !== "string") {
      if (text.toString().length <= maxLength) {
        return text.toString();
      } else {
        return text.toString().substring(0, maxLength) + "...";
      }
    } else {
      if (text.length <= maxLength) {
        return text;
      } else {
        return text.substring(0, maxLength) + "...";
      }
    }
  } else {
    return text;
  }
}

export const styleDate = (dateString, style='long') => {
  if (!dateString || dateString === "") return null;

  return new Date(dateString)
  .toLocaleDateString("fr",  {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}
